<template>
    <div class="layout-wrapper layout-navbar-full layout-horizontal layout-without-menu">

        <div class="layout-container">
            <!-- Navbar -->
            <NavBar />

            <!-- Layout container -->
            <div class="layout-page">
                <!-- Content wrapper -->
                <div class="content-wrapper">
                    
                    <!-- Menu -->
                    <MenuItem />
                    
                    <!-- Content -->
                    <div class="container-xxl flex-grow-1 container-p-y">

                        <h4 class="fw-bold py-3 mb-4"><span class="text-muted fw-light">NSIA ASSURANCE /</span> Fiche prospect</h4>

                    <div  v-if="!isAjout &&!isEdit&&!isFiche">
                        <button style="text-transform: none;"
                            class="btn btn-label-primary waves-effect mb-3" 
                            @click="displayAjout()">
                            <i class="pi pi-plus"></i>&nbsp;
                            Ajouter un prospect
                        </button>
                        <div class="row align-items-end">
                            <div class="col-2">
                                <div class="mt-2 mb-3">
                                    <label for="largeSelect" class="form-label">Filtrer par garantie</label>
                                    <select id="largeSelect" class="form-select form-select-lg" v-model="filter_garantie" @change=filterByGarantie()>
                                    <option v-for="garantie in garanties" :value="garantie.id">{{ garantie.libelle_garantie }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-2">
                                <div class="mt-2 mb-3">
                                    <label for="largeSelect" class="form-label">Filtrer par secteur</label>
                                    <select id="largeSelect" class="form-select form-select-lg" v-model="filter_secteur" @change="filterBySecteur()">
                                    <option v-for="sector in secteurs" :value="sector.id">{{ sector.libelle_sector }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-2">
                                <div class="mt-2 mb-3">
                                    <label for="largeSelect" class="form-label">Filtrer par commercial</label>
                                    <select id="largeSelect" class="form-select form-select-lg" v-model="filter_admin" @change=filterByAdmin()>
                                    <option v-for="user in admins" :value="user.id">{{ user.nom }} {{ user.prenoms }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-6 text-end">
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search" />
                                    <InputText v-model="filters['global'].value" placeholder="Rechercher" />
                                </span>
                            </div>
                        </div>
                        <DataTable 
                            v-model:filters="filters" :value="filter_prospects"   sortMode="multiple" paginator dataKey="id" :rows="10" 
                            :rowsPerPageOptions="[5,10, 30, 50, 100]" tableStyle="width:100%" filterDisplay="menu" 
                            :globalFilterFields="['nom_societe', 'effectif', 'dg', 'interlocuteur', 'statut', 'interesse', 'id_admin', 'date_create']"
                        >
                            <!-- paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}" -->
                            
                            <template #header>
                                <div class="flex justify-content-between">
                                    <!-- <Button 
                                        type="button" icon="pi pi-filter-slash" 
                                        label="Annuler la recherche" outlined 
                                        class="btn btn-label-primary waves-effect"
                                        @click="clearFilter()" 
                                    /> -->
                                    <button style="text-transform: none;"
                                        class="btn btn-label-primary waves-effect" 
                                        @click="clearFilter()" 
                                    >
                                        <i class="pi pi-filter-slash"></i>&nbsp;
                                        Annuler la recherche
                                    </button>

                                    
                                    <button style="text-transform: none;"
                                        class="btn btn-label-dark waves-effect" 
                                        @click="ExportExcel()" 
                                    >
                                    <span class="mdi mdi-file-download"></span>
                                       Exporter en excel
                                    </button>
                                    <h4>Nombre prospects : <span class="text-primary">{{ filter_prospects.length }}</span></h4>
                                </div>
                            </template>

                            

                            <Column field="nom_societe" header="Nom société" sortable></Column>
                            <Column field="effectif" header="Effectif" sortable></Column>
                            <Column field="dg" header="DG" sortable></Column>
                            <Column field="interlocuteur" header="Interlocuteur" sortable></Column>
                            <Column field="statut" header="Statut">
                                <template #body="slotProps">
                                    <span class="badge bg-label-primary me-1" v-if="slotProps.data.statut=='nouveau prospect'" style="text-transform: lowercase;">{{ slotProps.data.statut }}</span>
                                    <span class="badge bg-label-danger me-1" v-if="slotProps.data.statut=='tiède'" style="text-transform: lowercase;">{{ slotProps.data.statut }}</span>
                                    <span class="badge bg-label-success me-1" v-if="slotProps.data.statut=='intéressé'" style="text-transform: lowercase;">{{ slotProps.data.statut }}</span>
                                    <span class="badge bg-label-warning  me-1" v-if="slotProps.data.statut=='pas intéressé'" style="text-transform: lowercase;">{{ slotProps.data.statut }}</span>
                                </template>
                            </Column>
                            <Column field="interesse" header="Intéressé">
                                <template #body="slotProps">
                                    <span class="badge bg-label-primary me-1" v-if="slotProps.data.interesse=='oui'" style="text-transform: lowercase;">{{ slotProps.data.interesse }}</span>
                                    <span class="badge bg-label-danger me-1" v-else style="text-transform: lowercase;">{{ slotProps.data.interesse }}</span>
                                    
                                </template>
                            </Column>
                            <Column field="nom" header="Gestionnaire" sortable></Column>
                            <Column field="date_create" header="Date d'enregistrement" sortable="">
                                <template #body="slotProps">
                                    {{ new Date(slotProps.data.date_create).toLocaleDateString() }}
                                </template>
                            </Column>
                            <Column>
                                <template #body="slotProps">
                                    <button type="button" 
                                        class="btn btn-label-primary waves-effect" 
                                        data-bs-toggle="dropdown" aria-expanded="false"
                                    >
                                        <i  class="pi pi-bars"/>
                                    </button>
                                    <ul class="dropdown-menu">
                                        <li>
                                            <a 
                                                @click="shoowEditProspect(slotProps.data)"
                                                class="dropdown-item waves-effect" 
                                                href="javascript:void(0);"
                                            >
                                                Modifier la fiche
                                            </a>
                                        </li>
                                        <li>
                                            <a 
                                                @click="showModalStatut(slotProps.data)"
                                                class="dropdown-item waves-effect" 
                                                href="javascript:void(0);"
                                            >
                                                Modifier le statut
                                            </a>
                                        </li>
                                        <li>
                                            <a 
                                                @click="showFiche(slotProps.data)"
                                                class="dropdown-item waves-effect" 
                                                href="javascript:void(0);"
                                            >
                                                Fiche prospection
                                            </a>
                                        </li>
                                        <li>
                                            <a 
                                                @click="supprimer(slotProps.data)"
                                                class="dropdown-item waves-effect" 
                                                href="javascript:void(0);"
                                            >
                                                Supprimer
                                            </a>
                                        </li>
                                    </ul>
                                    <!-- 
                                        @click="showDonnees(slotProps.data)" <SplitButton label="preferences" :model="items"  class="mb-2"></SplitButton> -->
                                </template>
                            </Column>

                            <template #paginatorstart>
                                <Button type="button" class="btn btn-label-primary waves-effect" icon="pi pi-refresh" text @click="getProspects" />
                            </template>

                            <template #paginatorend>
                                <Button type="button" class="btn btn-label-primary waves-effect" icon="pi pi-download" text />
                            </template>

                        </DataTable>
                        </div>
                        <div class="row ">
                            <AjoutProspect @AjoutProspect="AjoutProspect" :prospections="natures_prospections" :garanties="garanties" :secteurs="secteurs" :isAjout="isAjout" :admins="admins"  @closeAjout="closeAjout()"/>
                        </div>
                        
                        <div class="row">
                            <EditProspectionVue :prospect="editProspect" @AjoutProspect="AjoutProspect" :prospections="natures_prospections" :garanties="garanties" :secteurs="secteurs" :isEdit="isEdit" :admins="admins"  @closeEdit="closeEdit()"></EditProspectionVue>
                        </div>
                        <div class="row">
                            <FicheProspect :prospect="editProspect" :isFiche="isFiche"  @closeFiche="closeFiche()"></FicheProspect>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
            <Dialog v-model:visible="display_statut" :style="{ width: '50vw' }" modal header="Modifier le statut du prospect"  position="center">
                <div class="container mt-4">
                    <form @submit="updateStatut($event)">
                         <div class="row">
                             <div class="col-12">
                                <div class="form-floating form-floating-outline">
                                   <select  class="form-select form-select-lg" data-style="btn-default" v-model="editProspect.statut">
                                    <option value="nouveau prospect">Nouveau prospect</option>
                                    <option value="pas intéressé">Pas interessé</option>
                                    <option value="intéressé">Interessé</option>
                                    <option value="tiède">Tiède</option>
                                    <option value="qualifié">Qualifié</option>
                                   </select>
                                   <label for="selectpickerBasic">Statut</label>
                               </div>
                             </div>
                         </div>
                         <button type="submit" class="btn w-100 btn-primary waves-effect waves-light">Modifier</button>
                     </form>
                     </div>
             </Dialog>
    </div>

</template>

<script>
// Import the CSS or use your own!
    import MenuItem from "@/components/MenuItem";
    import NavBar from "@/components/NavBar";
    import AjoutProspect from "@/components/AjoutProspect";
    import EditProspectionVue from "@/components/EditProspection.vue";
    import FicheProspect from "@/components/FicheProspect.vue";
    // import { menu } from "@/assets/vendor/js/menu.js";
    import "vue-toastification/dist/index.css";
    import { useToast } from "vue-toastification";
    const toast = useToast();
    // import { VDataTable } from 'vuetify/labs/VDataTable';
    import { apiUrl } from "@/constants/config";
    // import { Header, Item } from "vue3-easy-data-table";
    // import DataTable from 'datatables.net-vue3';

    // import { DataTable } from "@jobinsjp/vue3-datatable"
    // import "@jobinsjp/vue3-datatable/dist/style.css"
    // import DataTable from 'datatables.net-vue3';
    // import DataTablesCore from 'datatables.net-bs5';
    // import 'datatables.net-select';
    // import 'datatables.net-responsive';
    // DataTable.use(DataTablesCore);
    import DataTable from 'primevue/datatable';
    import Column from 'primevue/column';
    import ColumnGroup from 'primevue/columngroup';   // optional
    import Row from 'primevue/row';                   // optional
    import Dialog from 'primevue/dialog';
    import Calendar from 'primevue/calendar';
    import exportFromJSON from "export-from-json";
    import { FilterMatchMode, FilterOperator } from 'primevue/api';

    // const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };


    export default {
        name: 'ProspectsView',
        components: {
            MenuItem, NavBar, 
            // VDataTable, 
            DataTable, Column, ColumnGroup, Row, Dialog, Calendar, AjoutProspect,EditProspectionVue,
            FicheProspect
        },
        
        data(){
            return {
                prospects : [],
                garanties : [],
                secteurs : [],
                admins : [],
                natures_prospections : [],
                selection : {},
                editProspect : {},
                loading : true,
                display_edit : false,
                controleDatas : {bande_id : '', kg_moyen : '', date_controle : new Date()},
                data : {},
                controles : [],
                datas : {reference: '', date_entree : null, prix_unitaire:'', kg_moyen:'', ferme_id: '', effectif_entree: ''},
                display : false,
                display_statut : false,
                options : { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
                search: '',
                bandes: [], filters: null,
                isAjout : false,
                isEdit : false,
                isFiche : false,
                filter_garantie : '',
                filter_secteur : '',
                filter_admin : '',
                filter_prospects : [],
                items: [
                    {
                        label: 'Update',
                        icon: 'pi pi-refresh',
                        command: () => {
                            this.$toast.add({ severity: 'success', summary: 'Updated', detail: 'Data Updated', life: 3000 });
                        }
                    },
                    {
                        label: 'Delete',
                        icon: 'pi pi-times',
                        command: () => {
                            this.$toast.add({ severity: 'warn', summary: 'Delete', detail: 'Data Deleted', life: 3000 });
                        }
                    },
                    {
                        label: 'Vue Website',
                        icon: 'pi pi-external-link',
                        command: ($event) => {
                            this.showDonnees($event);
                        }
                    },
                    { label: 'Upload', icon: 'pi pi-upload', to: '/fileupload' }
                ]
            }
        },
        mounted(){
            this.getProspects();
            this.getAdmins()
            this.getSecteurs()
            this.getProspections()
            this.getGaranties()
        },
        beforeMount()
        {
            // toast.error("Une erreur s'est produite pendant l'envoie de votre message");
        },
        created() {
           
            this.initFilters();
        },
        
        methods:{
            ExportExcel(){
                
                const fileName = 'prospects'
                const exportType = exportFromJSON.types["xls"];
                exportFromJSON({data : this.prospects, fileName, exportType});
            },
            async getProspects()
            {
                const response = await this.$axios.get(`prospect/all?typeProfil=${this.$store.state.user.profil}&id=${this.$store.state.user.id}`)
                this.prospects = [...response.data.data]
                this.filter_prospects = [...response.data.data]
                this.loading = false
            },

            async getGaranties()
            {
                const response = await this.$axios.get('guarantees/all')
                this.garanties = [...response.data.data]
            },
            async getSecteurs()
            {
                const response = await this.$axios.get('sector/all')
                console.log(response.data);
                this.secteurs = [...response.data.data]
            },
            async getProspections()
            {
                const response = await this.$axios.get('prospection/all')
                this.natures_prospections = [...response.data.data]
            },
            async getAdmins()
            {
                const response = await this.$axios.get('admin/all')
                this.admins = [...response.data.data]
            },

            shoowEditProspect(donnees)
            {
                
                this.editProspect = {...donnees}
                this.isEdit = true

            },
            showFiche(donnees){
                this.editProspect = {...donnees}
                this.isFiche = true
            },
            showModalStatut(datas){
                
                this.editProspect = {...datas}
                this.display_statut = true
            },
            async AjoutProspect(){
                    this.getProspects()
                    this.isAjout = false
            },
            async AjoutControleBande(e){
                e.preventDefault();
                // console.log(this.datas);
                     let response = await this.$axios.post('prospect/add', this.controleDatas);
                    if(response.data.code ==404){
                        toast.error('Veuillez renseigner tous les champs svp!')
                        return
                    }
                    toast.success(response.data.message)
                    this.resetDatas()
                    this.display = false
                    this.controles.push(this.controleDatas)
            },
            async updateStatut(e){
                e.preventDefault()
                let datas = new FormData()
                datas.append('id', this.editProspect.id_prospect)
                datas.append('statut', this.editProspect.statut)
                let response = await this.$axios.post(`prospect/updateStatut`, datas);
                    
                    if(response.data.code ==400){
                        toast.error(response.data.message)
                        return
                    }
                    toast.success(response.data.message)
                    
                    this.display_statut = false
                    this.getProspects()
            },
        async supprimer(datas){
            this.$swal({
                title: 'NSIA ASSURANCE',
                text: "Voulez supprimer le prospect",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Supprimer'
                }).then(async (result) => {
                    if(result.isConfirmed){
                        const data = new FormData()
                        data.append('id', datas.id_prospect)
                        const response = await this.$axios.post(`prospect/delete`,data)
                        if(response.code){
                            toast.error(response.data.message)
                            return
                        } else{
                            toast.success(response.data.message)
                            this.getProspects()
                        }
                    }
            });
            },
            getPourcent(datas){
                let pourcentage = 0
                let somme = 0
              datas.mortalites.forEach(element => {
                somme += element.nombre_mortalite
              });
              pourcentage = (somme * 100)/datas.effectif_entree

              return Math.trunc(pourcentage) 
            },
            clearFilter() {
                this.initFilters();
                this.resetFilter()
                this.filter_prospects = [...this.prospects]
            },

            initFilters() {
                this.filters = {
                    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    reference: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                };
            },
            displayAjout(){
                this.isAjout = true
            },
            closeAjout(){
                this.isAjout = false
            },
            closeEdit(){
                this.isEdit = false
            },
            closeFiche(){
                this.isFiche = false
            },
            resetDatas(){
                this.datas.reference = ''
                this.datas.date = new Date()
                this.datas.effectif_entree = ''
                this.datas.kg_moyen = ''
                this.datas.prix_unitaire = ''
                this.datas.ferme_id = ''
            },
            onRowSelect(event){
                this.selection = {...event.data}
                console.log(this.selection);
            },
            onRowUnselect(event){
                console.log('deselection');
            },
            filterByGarantie(){
                this.filter_admin = ''
                this.filter_secteur = ''
                this.filter_prospects = this.prospects.filter(el=>{
                    return el.id_garanties == this.filter_garantie
                })
            },
            filterBySecteur(){
                this.filter_garantie = ''
                this.filter_admin = ''
                this.filter_prospects = this.prospects.filter(el=>{
                    return el.id_sector == this.filter_secteur
                })
            },
            filterByAdmin(){
                this.filter_garantie = ''
                this.filter_secteur = ''
                this.filter_prospects = this.prospects.filter(el=>{
                    return el.id_admin == this.filter_admin
                })
            },
            resetFilter(){
                this.filter_admin = ''
                this.filter_garantie = ''
                this.filter_secteur = ''
            }
        }
    }
</script>

<style scoped>
    .text-primary{
    color: #ce9c2b !important;
}
    /* @import 'datatables.net-dt'; */

    /* .p-datatable .p-datatable-header
    {
        border: none !important;
    } */

</style>
